import { render, staticRenderFns } from "./samplePoint.vue?vue&type=template&id=fbf40c80&"
import script from "./samplePoint.vue?vue&type=script&lang=js&"
export * from "./samplePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports